import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";

import Error from "./pages/error";
import AdminLayout from "./components/layout/AdminLayout";
import ProtectedRoute from "./pages/Admin/components/ProtectedRoute";

// Admin Auth
import AdminLogin from "./pages/Admin/adminLogin";

// Control Center
import AdminDashboard from "./pages/Admin/adminDashboard";

// Commerce Workspaces
import AdminOrders from "./pages/Admin/adminOrders";
import OrderDetails from "./pages/Admin/adminParticularOrder";
import AdminCustomers from "./pages/Admin/adminCustomers";
import AdminProductsListingPage from "./pages/Admin/adminViewProducts";
import AdminAddProducts from "./pages/Admin/adminAddProduct";
import InventoryWorkspace from "./pages/Admin/InventoryWorkspace";
import CouponManagement from "./pages/Admin/adminCoupons";
import PaymentsWorkspace from "./pages/Admin/PaymentsWorkspace";

// System & Support
import ContactManagement from "./pages/Admin/adminContacts";
import SystemHealthWorkspace from "./pages/Admin/SystemHealthWorkspace";

const ReactRouterSetup = () => {
    return (
        <Router>
            <Routes>
                {/* Public login routes */}
                <Route path="/" element={<AdminLogin />} />
                <Route path="/login" element={<AdminLogin />} />

                {/* Protected Admin Control Center Layout */}
                <Route
                    element={
                        <ProtectedRoute>
                            <AdminLayout />
                        </ProtectedRoute>
                    }
                >
                    {/* Control Center */}
                    <Route path="/dashboard" element={<AdminDashboard />} />
                    <Route path="/command-center" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/command" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/analytics" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/admin" element={<Navigate to="/dashboard" replace />} />

                    {/* Commerce */}
                    <Route path="/orders" element={<AdminOrders />} />
                    <Route path="/order/:id" element={<OrderDetails />} />
                    <Route path="/returns" element={<Navigate to="/orders" replace />} />
                    <Route path="/return/:id" element={<Navigate to="/orders" replace />} />
                    <Route path="/customers" element={<AdminCustomers />} />
                    <Route path="/view-products" element={<AdminProductsListingPage />} />
                    <Route path="/add-products" element={<AdminAddProducts />} />
                    <Route path="/products" element={<Navigate to="/view-products" replace />} />
                    <Route path="/inventory" element={<InventoryWorkspace />} />
                    <Route path="/coupons" element={<CouponManagement />} />
                    <Route path="/payments" element={<PaymentsWorkspace />} />

                    {/* Support & System */}
                    <Route path="/contacts" element={<ContactManagement />} />
                    <Route path="/system-health" element={<SystemHealthWorkspace />} />

                    {/* Legacy / Hidden Routes Redirections */}
                    <Route path="/fulfillment" element={<Navigate to="/orders" replace />} />
                    <Route path="/exceptions" element={<Navigate to="/orders" replace />} />
                    <Route path="/audit-log" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/intelligence/*" element={<Navigate to="/dashboard" replace />} />
                </Route>

                {/* 404 Fallback */}
                <Route path="*" element={<Error />} />
            </Routes>
        </Router>
    );
};

export default ReactRouterSetup;
